import React from "react";
import { Col, Container, Row } from "reactstrap";

function HeaderSection() {
    return (
        <>
            <Container fluid className="headerSection">
                <Row>
                    <Col
                        md={12}
                        className="d-flex justify-content-start  align-items-center h-100 mt-5"
                    >
                        <h1 className="mt-5 headerSection__text">
                            Find Professional Detailing Supplies
                            <br /> Near You
                        </h1>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default HeaderSection;
